import { render, staticRenderFns } from "./EventTypeSelection.vue?vue&type=template&id=4c516c7c&"
import script from "./EventTypeSelection.vue?vue&type=script&lang=js&"
export * from "./EventTypeSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports